import * as trace from 'owa-trace';

import {
    Calendar,
    addToCalendarsCache,
    getCalendarEntry,
    removeCalendarFromCalendarsCache,
} from 'owa-calendar-cache';

import CalendarActionFolderIdResponse from 'owa-service/lib/contract/CalendarActionFolderIdResponse';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { replaceCalendar } from 'owa-calendar-surface-calendars-store';

export function processRenameServiceResponse(
    response: CalendarActionFolderIdResponse,
    calendar: Calendar,
    calendars: Calendar[],
    newCalendarName: string
): void {
    // response.WasSuccessful should be enough but there's a bug in ecosystem where a failed rename call will
    // still return wasSuccessful=true, bug 378078
    if (response.WasSuccessful && response.ErrorCode === 0) {
        let oldCalendarEntry = getCalendarEntry(calendar);

        removeCalendarFromCalendarsCache(calendar);
        addToCalendarsCache({
            ...oldCalendarEntry,
            calendarId: {
                itemId: response.NewCalendarEntryId,
                mailboxInfo: calendar.id.mailboxInfo,
            },
            FolderId: response.NewFolderId,
            CalendarName: calendar.displayName,
        });

        let foundCalendarResult = findInArray(calendars, item => {
            return item.id.id === calendar.id.id;
        });

        if (foundCalendarResult) {
            let colorScheme = foundCalendarResult.item.colorScheme;
            let newCalendar: Calendar = {
                id: { id: response.NewCalendarEntryId.Id, mailboxInfo: calendar.id.mailboxInfo },
                displayName: newCalendarName,
                colorScheme: colorScheme,
            };
            replaceCalendar(newCalendar, foundCalendarResult.index);
        } else {
            trace.errorThatWillCauseAlert(
                `[renameCalendar] Cannot find calendar id: ${calendar.id}`
            );
        }
    }
}
